// React
import React from 'react'

export default ({ action, alert, disabled, flat, style, text }) => {
	let className = ''
	if (alert) {
		className = 'capps-button alert'
	}
	else if (flat || disabled) {
		className = 'capps-button flat'
	}
	else {
		className = 'capps-button primary'
	}
	return (
		<center>
			<div className={className} onTouchTap={!disabled ? action : () => null} style={style}>
				{text}
			</div>
		</center>
	)
}



// WEBPACK FOOTER //
// ./src/Components/Display/Button.js